// @ts-expect-error upstream is not migrated to TypeScript
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import UIFloatingAlertList from 'UIComponents/alert/UIFloatingAlertList';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import withErrorBoundary from '../ErrorBoundary';
import { UI_REQUEST_PRODUCT_BUTTON } from '../_core/common/constants/ErrorBoundaryNames';
import { upgradeDataPropsInterface } from '../_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
import { track } from '../_core/common/eventTracking/tracker';
import { requestSKU } from '../_core/upgrade/requestSKU';
import { _getHubAndTierProperties, getSource, getUpgradeDataTrackingProperties } from '../ums/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RequestProductPropsInterface = Object.assign({}, upgradeDataPropsInterface, {
  use: PropTypes.string,
  className: PropTypes.string
});
const getTrackingProperties = upgradeData => {
  const {
    apiName,
    upgradeProduct,
    app,
    screen,
    uniqueId,
    upgradeKey,
    pointType,
    feature,
    upgradeSource
  } = upgradeData;
  const apiNameMaybe = apiName || UpgradeProductToApiNameMap[upgradeProduct];
  const {
    hub,
    tier
  } = _getHubAndTierProperties({
    upgradeProduct,
    apiName: apiNameMaybe
  });
  const source = upgradeData.source || getSource(upgradeData.app, upgradeData.screen, upgradeData.uniqueId);
  return {
    app,
    screen,
    uniqueId,
    upgradeProduct,
    apiName: apiNameMaybe,
    source,
    upgradeKey,
    pointType,
    feature,
    upgradeSource,
    hub,
    tier
  };
};
const UIRequestProductButton = ({
  upgradeData,
  isUpgradePoint,
  buttonSize,
  className,
  onClick = () => {},
  use = 'primary'
}) => {
  const [showModal, setShowModal] = useState(false);
  const [localAlertStore] = useState(() => {
    return FloatingAlertStore.newFloatingAlertStore();
  });
  useEffect(() => {
    track('requestProductButton', Object.assign({
      action: 'viewed'
    }, getTrackingProperties(upgradeData)));
  }, [upgradeData]);
  const handleSendRequest = () => {
    requestSKU({
      apiName: upgradeData.apiName || UpgradeProductToApiNameMap[upgradeData.upgradeProduct]
    }).then(() => {
      setShowModal(false);
      localAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestProduct.alerts.onSuccessAlert.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestProduct.alerts.onSuccessAlert.title"
        }),
        type: 'success'
      });
    }).catch(__error => {
      localAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestProduct.alerts.onFailureAlert.message"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.requestProduct.alerts.onFailureAlert.title"
        }),
        type: 'danger'
      });
    });
  };
  const handleButtonClick = () => {
    setShowModal(true);
    onClick();
    track('requestProductButton', Object.assign({
      action: 'clicked'
    }, getTrackingProperties(upgradeData)));
    if (isUpgradePoint) {
      track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, getUpgradeDataTrackingProperties(upgradeData)));
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFloatingAlertList, {
      alertStore: localAlertStore
    }), /*#__PURE__*/_jsx(UIButton, {
      onClick: handleButtonClick,
      use: use,
      "data-test-id": "request-product-button",
      className: className,
      size: buttonSize,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "purchaseMotions.requestProduct.button.defaultButtonCopy"
      })
    }), showModal && /*#__PURE__*/_jsxs(UIModal, {
      use: "success",
      width: 540,
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: () => {
            setShowModal(false);
          }
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.requestProduct.modal.title"
          })
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx("p", {
          className: "p-right-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.requestProduct.modal.description"
          })
        })
      }), /*#__PURE__*/_jsx(UIDialogFooter, {
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: handleSendRequest,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "purchaseMotions.requestProduct.modal.primaryCta"
          })
        })
      })]
    })]
  });
};
export default withErrorBoundary(UIRequestProductButton, {
  boundaryName: UI_REQUEST_PRODUCT_BUTTON
});